<template>
  <mdb-modal size="lg"  :show="show" @close="$emit('close')">
    <mdb-modal-header>
      <mdb-modal-title>Ncs 훈련과정 선택</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body style="font-size:15px">
      <div class="mb-3">
        <span class="bolder">기준 연도: </span>
        <select v-model="baseYear" class="select-underline">
          <option v-for="(year, i) in baseYears" :key="i">{{year}}</option>
        </select>
      </div>
      <div v-if="baseYear">
        <div v-for="(t, i) in trainings[baseYear]" :key="i" class="pointer" @click="onSelectTraining(t)">
          <label  :class="training._id===t._id ? 'bolder title' : ''">
            <input type="radio" name="training" :checked="training._id===t._id">
              <span v-if="t.code"> {{t.code}} /</span>
              {{t.name}}
          </label>
        </div>
      </div>
      <div class="text-center mt-4">
        <mdb-btn color="primary" class="p-2 px-4" @click.native="onOk">선택</mdb-btn>
        <mdb-btn color="secondary" class="p-2 px-4" @click.native="$emit('close')">취소</mdb-btn>
      </div>
    </mdb-modal-body>
  </mdb-modal>
</template>
<script>
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import NcsTraining from '@/models/NcsTraining'
export default {
  name: 'NcsTrainingSelectDlg',
  components: { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody },
  props: ['org', 'show', 'value'],
  data: () => ({
    TAG: 'NcsTrainingSelectDlg',
    trainings: {},
    baseYear: 0,
    modal: false,
    training: {}
  }),
  computed: {
    baseYears () {
      return Object.keys(this.trainings).sort().reverse()
    }
  },
  methods: {
    async load () {
      if (!this.org) return
      this.trainings = await NcsTraining.get({ org: this.org._id })
      this.baseYear = Object.keys(this.trainings).sort().reverse()[0]
      for (const key in this.trainings) {
        this.trainings[key] = this.trainings[key].sort()
        const ix = this.trainings[key].findIndex(t => t._id === this.value._id)
        if (ix !== -1) {
          this.training = this.trainings[key][ix]
          this.baseYear = key
        }
      }
    },
    onSelectTraining (training) {
      this.training = training
    },
    onOk () {
      if (!this.training._id) alert('먼저 선택하세요.')
      const { _id, name } = this.training
      this.$emit('input', { _id, name })
      this.$emit('close')
    }
  },
  watch: {
    org: 'load',
    modal () {
      if (!this.modal) {
        this.$emit('close')
      }
    }
  },
  created () { this.load() }
}
</script>
